import React, { Component } from "react";
import { withRouter } from "react-router";
import { withStyles } from "material-ui/styles";
import Button from "material-ui/Button";
import { Line } from "react-chartjs-2";
import 'chartjs-plugin-datalabels'; 
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import Page from "../Page";
import { getColor } from "../../utils/colors";
import { randomNum } from '../../utils/demos';

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
const genLineData = (moreData = {}, moreData2 = {}) => {
  return {
    labels: MONTHS,
    datasets: [
      {
        label: 'Cash',
        backgroundColor: 'rgba(255, 99, 132, 0.8)',
        borderColor: 'rgba(255, 99, 132, 1)',
        borderWidth: 1,
        data: [
          423413,
          637494,
          234945,
          99503,
          129438,
          127394,
          82741,
        ],
        ...moreData,
      },
      {
        label: 'Credit Card',
        backgroundColor: 'rgba(54, 162, 235, 0.8)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 1,
        data: [
          123413,
          837494,
          834945,
          649503,
          129438,
          527394,
          82741,
        ],
        ...moreData2,
      },
      {
        label: 'eWallet',
        backgroundColor: 'rgba(255, 206, 86, 0.8)',
        borderColor: 'rgba(255, 206, 86, 1)',
        borderWidth: 1,
        data: [
          223413,
          437494,
          534945,
          249503,
          529438,
          827394,
          42741,
        ],
        ...moreData2,
      },
      {
        label: 'Others',
        backgroundColor: 'rgba(75, 192, 192, 0.8)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
        data: [
          523413,
          737494,
          834945,
          349503,
          429438,
          727394,
          62741,
        ],
        ...moreData2,
      },
    ],
  };
};

const TodayCollection = () => (
  // <div style={{width:"100%"},{textAlign:"center"}}>
  //   <div className='header'>
  //     <h1 className='title'>Todays Collection</h1>
  //   </div>
  //   <div style={{width:"800px"}}>
  //     <Pie data={genPieData()} />
  //   </div>
  // </div>

  <Page title="Bill Payment">
    <Row>
    <Row>
        <Col xl={11} lg={12} md={12}>
          <Card>
            {/* <CardHeader>Stacked Line</CardHeader> */}
            <CardBody>
              <Line
                data={genLineData()}
                options={{
                  scales: {
                    xAxes: [
                      {
                        scaleLabel: {
                          display: true,
                          labelString: 'Month',
                        },
                      },
                    ],
                    yAxes: [
                      {
                        stacked: true,
                        scaleLabel: {
                          display: true,
                          labelString: 'Value',
                        },
                      },
                    ],
                  },
                }}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Row>
  </Page>
);

export default TodayCollection;



// WEBPACK FOOTER //
// ./src/components/reports/BillPayment.js